/**
 * Checks whether an atom type key in attachments already exists.
 *
 * @param {Correlation} correlation
 * @param {string} atomType
 */
export function hasAttachmentAtomType(correlation, atomType) {
    return correlation.attachment[atomType] &&
        correlation.attachment[atomType].length > 0
        ? true
        : false;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFzQXR0YWNobWVudEF0b21UeXBlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxpdGllcy9jb3JyZWxhdGlvbi9oYXNBdHRhY2htZW50QXRvbVR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7Ozs7O0dBS0c7QUFDSCxNQUFNLFVBQVUscUJBQXFCLENBQ25DLFdBQXdCLEVBQ3hCLFFBQWdCO0lBRWhCLE9BQU8sV0FBVyxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUM7UUFDckMsV0FBVyxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxNQUFNLEdBQUcsQ0FBQztRQUMzQyxDQUFDLENBQUMsSUFBSTtRQUNOLENBQUMsQ0FBQyxLQUFLLENBQUM7QUFDWixDQUFDIn0=